module.exports = __webpack_public_path__ + "static/media/zhuo_chen_resume_09_01_2022.56f5d1c7.pdf";